module.exports = __webpack_public_path__ + "img/header-memoireRingsGrowingMemoires@2x.1c10cbd.webp";